import axios from './http'

export function permInit(token){
  return axios({
    url: '/api/perm/init',
    method: 'get',
    headers: {
      'authorization': token
    }
  })
}

export function searchPerm(token,userId){
  return axios({
    url: '/api/perm/searchPerm/'+userId,
    method: 'get',
    headers: {
      'authorization': token
    }
  })
}

export function updateUserPerm(token,userId,perms){
  return axios({
    url: '/api/perm/updateUserPerm/'+userId,
    method: 'put',
    data: perms,
    headers: {
      'authorization': token
    }
  })
}

export function isOvAdmin(token){
  return axios({
    url: '/api/perm/isOvAdmin',
    method: 'get',
    headers: {
      'authorization': token
    }
  })
}
